module.exports = __webpack_public_path__ + "33d5f0d956f3fc30bc51f81047a2c47d.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Black.woff2
// module id = 983
// module chunks = 0